/**
 * Escapes special regex characters in a string to make it safe for use in RegExp constructor
 * @param str - The string to escape
 * @returns The escaped string safe for regex use
 */
export const escapeRegexCharacters = (str: string): string =>
  str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Creates a validation regex for numeric input based on locale-specific separators
 * @param options - Configuration for regex creation
 * @returns A RegExp for validating numeric input
 */
export const createNumericValidationRegex = ({
  groupingSeparator,
  decimalSeparator,
  allowNegative,
  maxDecimalPlaces,
}: {
  groupingSeparator: string;
  decimalSeparator: string;
  allowNegative: boolean;
  maxDecimalPlaces: number;
}): RegExp => {
  const escapedDecimalSeparator = escapeRegexCharacters(decimalSeparator);
  const escapedGroupingSeparator = escapeRegexCharacters(groupingSeparator);

  const groupingExpr =
    groupingSeparator === ''
      ? '\\d*'
      : '[' + escapedGroupingSeparator + '0-9]*';

  if (maxDecimalPlaces === 0) {
    return new RegExp(
      '^' +
        (allowNegative ? '[-+]?' : '') +
        '(0?|[1-9](' +
        groupingExpr +
        '))$',
    );
  }

  return new RegExp(
    '^' +
      (allowNegative ? '[-+]?' : '') +
      '(0?|[1-9](' +
      groupingExpr +
      '))([' +
      escapedDecimalSeparator +
      '](\\d{0,' +
      maxDecimalPlaces +
      '}))?$',
  );
};
